export const Label = 'Відділення або поштомат';
